<template>
    <div>
        <Section>
            <LabelHeader border>
                <div slot="before">
                    <span>室内主动定位导航(微信版)</span>
                </div>
                <div slot="middle">
                    <span style="color: #3384f7">如有修改地图POI名称，请同步调整对应POI位置点</span>
                </div>
                <div slot="after">
                    <span class="fs-12px colorA3 mr-10px">上线<font color="red">23</font>个</span>
                    <Button type="primary" size="small">+ 创建推荐</Button>
                </div>
            </LabelHeader>

            <div style="padding: 20px">
                <Table border :columns="columns" :data="data"></Table>
                <Page :total="100" :page-size="10" style="text-align: right; margin-top: 20px"></Page>
            </div>
        </Section>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'

    import { Table, Page, Button } from 'iview';

    export default {
        name: "TTable1",
        data () {
            return {
                columns: [
                    {
                        title: '推荐序号',
                        key: 'no',
                        align: 'center',
                        minWidth: 90
                    },
                    {
                        title: '最近修改时间',
                        key: 'updateTime',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: '推荐名称',
                        key: 'name',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: 'POI位置点',
                        key: 'addr',
                        align: 'center',
                        minWidth: 300
                    },
                    {
                        title: 'POI个数',
                        key: 'num',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: '自定义图标',
                        align: 'center',
                        minWidth: 100,
                        render: (h, params) => {
                            if(params.row.image) {
                                return h('img', {src: params.row.image, style: {
                                        width: '30px',
                                        height: '30px'
                                    }});
                            }
                            else {
                                return h('span', { style: {
                                        display: 'inline-block',
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        backgroundColor: '#CCCCCC'
                                    }});
                            }
                        }
                    },
                    {
                        title: '操作',
                        width: 200,
                        render: (h, params) => {

                            let btnStyle = {
                                padding: '0 10px'
                            };

                            return h('div', [
                                h('a', {style: btnStyle}, '查看'),
                                h('a', {style: btnStyle}, '编辑'),
                                h('a', {style: btnStyle}, '删除')
                            ]);
                        }
                    }
                ],
                data: []
            }
        },
        mounted () {

            let data = [];

            for(let i = 0; i < 10; i++) {
                data.push({
                    no: i,
                    updateTime: '2019-2-13 12:11:29',
                    name: '前台',
                    addr: 'F1,F2,F3',
                    num: 12,
                    image: ''
                })
            }

            this.data = data;

        },

        components: {
            LabelHeader,
            Table,
            Button,
            Page
        }
    }
</script>

<style scoped>
</style>
